var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagColourful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M21 6.21v9.739c0 .397-.254.769-.66.93-6.28 2.469-7.565-2.234-14.197.746V6.585c.206-.142.383-.321.523-.528 6.934-2.617 6.598 2.048 12.571-.706C20.043 4.978 21 5.4 21 6.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4350F7",
    d: "M7 4.968a1.96 1.96 0 01-.857 1.617v13.642a.78.78 0 01-.786.773h-.714a.78.78 0 01-.786-.773V6.585a1.948 1.948 0 01-.497-2.741 2.018 2.018 0 012.783-.49C6.68 3.72 7 4.323 7 4.967z"
  }))));
}

export default SvgFlagColourful;